import React from 'react';
import { ListItem, Box } from '@mui/material';
import { TallyCompany } from '../../../../types/tally';
import CompanyDetails from './companyListItem/CompanyDetails';
import CompanyActions from './companyListItem/CompanyActions';

interface TallyCompanyListItemProps {
  company: TallyCompany;
  onFetchDetails: (company: TallyCompany) => void;
  onAddCompany: (company: TallyCompany) => void;
  onEditGst: (companyName: string) => void;
  onSaveGst: (companyName: string) => void;
  onCancelEditGst: (companyName: string) => void;
  onGstChange: (companyName: string, value: string) => void;
  onFetchVendorDetails: (companyName: string) => void;
  onDownloadCorruptedVendors: (companyName: string) => void;
}

const TallyCompanyListItem: React.FC<TallyCompanyListItemProps> = props => {
  const { company, onGstChange, ...rest } = props;

  return (
    <ListItem
      key={company.name}
      sx={{
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        gap: { xs: 1, sm: 2 },
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        <CompanyDetails company={company} onGstChange={onGstChange} />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 1, flexWrap: 'wrap' }}>
        <CompanyActions company={company} {...rest} />
      </Box>
    </ListItem>
  );
};

export default TallyCompanyListItem;
